// extracted by mini-css-extract-plugin
export default {"icon":"navigationConfig_icon__JNREn"};